import * as Sentry from '@sentry/nextjs'
import { DefaultError, useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { logger } from '@nx/utils/logger'

import { patchBid } from './patchBid'

export function usePatchBid({ baseURL }: { baseURL: string }) {
  return useMutation<
    Awaited<ReturnType<typeof patchBid>>,
    AxiosError<DefaultError>,
    Omit<Parameters<typeof patchBid>[0], 'baseURL'>
  >({
    mutationFn: (props) =>
      patchBid({
        ...props,
        baseURL,
      }),
    onError: (data) => {
      logger.error(data)
      Sentry.captureException(data)
    },
  })
}
